import axiApi from "ApiCaller";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useEffect, useState, useRef} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import TableImports from "./imports/TableImports";
import navs from "./navs";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";

const buttonsActions = new ButtonsActions();
const ViewImports = () => {
    const {t: _Tr} = useTranslation("routes");
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const items = useRef(new ItemsModel());
    const [itemsShow, setItemsShow] = useState([]);

    const [buttonsTB, setButtonsTB] = useState(buttonsActions);

    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);

    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        // { name: "Importaciones", current: true }
        {name: _Tr("labels.importations"), current: true},
    ];

    useEffect(() => {
        // let title = "Importaciones"
        let buttons = {...buttonsTB};
        buttons.title = _Tr("labels.importations");
        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;
        buttons.delete.active = true;
        buttons.delete.onClick = onClickDelete;
        buttons.edit.active = true;
        buttons.edit.onClick = onClickEdit;

        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchImports();

        fetchImports();
    }, []);

    function onClickAdd() {
        navigate("/asset-management/imports/import/");
    }

    const onClickEdit = (e) => {
        if (items.current.chosen.length !== 1) {
            return false;
        }
        let idx = parseInt(items.current.chosen[0]);
        let token = items.current.showed[idx].token;
        navigate(`/asset-management/imports/import/${token}/`);
    };

    const onClickDelete = () => {
        AlertQuestion.warning(
            "Borrar",
            `Se borraran los ${items.current.chosen.length} seleccionados`
        ).then((resp) => {
            if (resp.isConfirmed) {
                let ids = [];
                for (let row of items.current.chosen) {
                    ids.push(items.current.showed[row].token);
                }
                axiApi
                    .delete(`/api/inventory/imports/`, {data: {ids: ids}})
                    .then((resp) => {
                        if (resp.data.status) {
                            setItemsShow(
                                items.current.showed.filter(
                                    (_item) => !ids.includes(_item.token)
                                )
                            );
                        } else {
                            console.log("error al borrar el grupo");
                            resp.data.message && console.error(resp.data.message);
                            Alert.warning(
                                "error en el servicio",
                                "Avisar al administrador"
                            );
                        }
                    })
                    .catch((error) => {
                        console.error("Error al enviar la solicitud:", error);
                        Alert.error("Error en el servidor", "Avisar al administrador");
                    });
            }
        });
    };

    function clickRow(e) {
        let idx, checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector("input[type='checkbox']");
        }
        idx = parseInt(checkbox.value);
        let buttons = {...buttonsTB};

        if (items.current.chosen.includes(idx)) {
            items.current.chosen = items.current.chosen.filter((e) => e !== idx);
            checkbox.checked = false;
        } else {
            items.current.chosen.push(idx);
            checkbox.checked = true;
        }
        buttons.delete.disabled = !(items.current.chosen.length > 0);
        buttons.edit.disabled = !(items.current.chosen.length === 1);
        setButtonsTB(buttons);
    }

    const fetchImports = () => {
        setIsLoading(true);
        axiApi
            .get(`/api/inventory/`, {
                params: pagerModelRef.current.paging.getParams(),
            })
            .then((resp) => {
                items.current.showed = resp.data.items;
                setItemsShow(resp.data.items);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination
                pagerModel={pagerModelRef.current}
                stickyTopValue="125px"
            />
            <div className="row">
                <div className="col-md col-12" style={{width: "40%"}}>
                    <div className="col">
                        <LoaderSpinner isLoading={isLoading}>
                            <TableImports items={itemsShow} onClickRow={clickRow} />
                        </LoaderSpinner>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ViewImports;
